module.exports = __webpack_public_path__ + "img/angela-sung-light-and-dark.aa65226.jpg";